<template>
  <div id="app">
    <ControlPanel />
    <ErrorView />
    <MapView />
    <TaxaView />
    <Spinner />
  </div>
</template>

<script>
import ControlPanel from "./components/ControlPanel.vue";
import ErrorView from "./components/ErrorView.vue";
import MapView from "./components/MapView.vue";
import Spinner from "./components/Spinner.vue";
import TaxaView from "./components/TaxaView.vue";

export default {
  name: "app",
  components: {
    ControlPanel,
    ErrorView,
    MapView,
    Spinner,
    TaxaView
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
section {
  border: 1px solid lightgray;
}
</style>
